import {ICheckboxProps, Checkbox as NBCheckbox} from 'native-base';
import React from 'react';
import {useTheme} from 'styled-components/native';

interface CheckboxProps extends ICheckboxProps {
  bgColor?: string;
}

const Checkbox = (props: CheckboxProps) => {
  const theme = useTheme();
  const {bgColor = theme.colors.info, ...rest} = props;
  const {isChecked} = rest;

  return (
    <NBCheckbox
      borderRadius={'none'}
      style={{backgroundColor: isChecked ? bgColor : 'white'}}
      {...rest}
    />
  );
};

export default Checkbox;
